import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import { PaymentMethodCreateRequestDTO } from './PaymentMethod.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function listPaymentMethodInvoice(id?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/paymentMethods`,
    null,
  )) as unknown;

  return result as PageResult<PaymentMethodCreateRequestDTO>;
}

export async function createPaymentMethodInvoice(
  obj: PaymentMethodCreateRequestDTO,
) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/paymentMethods`,
    values,
    null,
  )) as unknown;

  return result as PaymentMethodCreateRequestDTO;
}

export async function deletePaymentMethodInvoice(
  invoiceId: number,
  id: number,
) {
  const result = await api.remove(
    `${CONTROLLER_URL}/${invoiceId}/paymentMethods/${id}`,
    {},
    null,
  );

  return result;
}

export async function getPaymentMethodInvoiceId(
  invoiceId: number,
  id: number,
): Promise<PaymentMethodCreateRequestDTO> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/paymentMethods/${id}`,
    null,
  )) as unknown;
  return result as PaymentMethodCreateRequestDTO;
}

export async function updatePaymentMethodInvoice(
  obj: PaymentMethodCreateRequestDTO,
): Promise<PaymentMethodCreateRequestDTO> {
  const { invoiceId, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/paymentMethods`,
    values,
    null,
  )) as unknown;
  return result as PaymentMethodCreateRequestDTO;
}
